@if(chatID() && chatID().length > 0) {
  <div 
    class="actions-footer-bar__chatbot-icon" 
    [ngClass]="{'hidden' : !dataChatService.hideChat()}"
    (click)="toggleChatView()" 
  >
    <img [src]="dataChatService.chatIcon()">
  </div>

  <div class="chatbot-wrapper" [ngClass]="{'hide-chat': dataChatService.hideChat(), 'full-screen': isFullScreen()}">
      <app-chatbot [chatID]="chatID()"></app-chatbot>
  </div>
}
